/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  CLEAR_NEW_NOTE_FORM,
  FETCH_CONSENT_DOCUMENTS_FOR_PARTICIPANT_ERROR,
  FETCHED_CONSENT_DOCUMENTS_FOR_PARTICIPANT,
  FETCHING_CONSENT_DOCUMENTS_FOR_PARTICIPANT,
  POST_NEW_NOTE_ERROR,
  PUBLISH_DOCUMENTS_METADATA_FOR_ADD_NOTES,
  SHOW_ADD_NOTE_HIDE_VIEW,
  UPDATE_ADD_NOTE_CONSENT_GID,
  POST_NEW_NOTE
} from '../actions/actionTypes';

const initialNewNoteState = {
  isFetching: false,
  noteType: null,
  participantId: null,
  error: null,
  documentsMetadata: null,
  consentGid: null,
  consentingGid: null,
  consentDocumentData: null,
  noteSuccess: false,
  origin: 3
};

const newNoteReducer = (state = initialNewNoteState, action) => {
  switch (action.type) {
    case FETCHING_CONSENT_DOCUMENTS_FOR_PARTICIPANT:
      return Object.assign({}, state, { isFetching: true });
    case FETCHED_CONSENT_DOCUMENTS_FOR_PARTICIPANT:
      return Object.assign({}, state, { isFetching: false, consentDocumentData: action.payload });
    case FETCH_CONSENT_DOCUMENTS_FOR_PARTICIPANT_ERROR:
      return Object.assign({}, state, { isFetching: false, error: action.payload });
    case PUBLISH_DOCUMENTS_METADATA_FOR_ADD_NOTES:
      return Object.assign({}, state, {
        consentGid: action.payload.consentGid,
        noteType: 'DOCUMENT',
        consentingGid: action.payload.consentingGid
      });
    case CLEAR_NEW_NOTE_FORM:
      return Object.assign({}, {}, initialNewNoteState);
    case UPDATE_ADD_NOTE_CONSENT_GID:
      return Object.assign({}, state, { consentGid: action.payload });
    case SHOW_ADD_NOTE_HIDE_VIEW:
      return Object.assign({}, state, { origin: action.payload, error: null });
    case POST_NEW_NOTE:
      return Object.assign({}, state, { noteSuccess: true, error: null });
    case POST_NEW_NOTE_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

export default newNoteReducer;
